import { __assign, __makeTemplateObject, __read, __rest } from "tslib";
import React, { forwardRef, useCallback, useEffect, useRef, useState, } from 'react';
import styled from 'styled-components';
import { extractCompleteTime, isHourType, isMinuteType, useIds } from './utils';
import { TimeSelectPanel } from './TimeSelectPanel';
import { useInputPropsMergedWithFormFieldContext } from '../FormField/FormFieldContext/FormFieldContext';
import { extractPropsForInputComponent } from '../internal/extract-props/extractPropsForInputComponent';
import { useTimeselectHooks } from './reducer/useTimeselectHooks';
import { inputChange, selectSelectorTimeType } from './reducer/actions';
import { useForkRef } from '../../utils/hooks/useForkRef';
import { TimeselectInput } from './TimeselectInput';
import { boxSizingBorderBox } from '../../utils/styled-components/extends';
import { useCompositeComponentFocusHandlers } from '../internal/useCompositeComponentFocusHandlers/useCompositeComponentFocusHandlers';
export var Timeselect = forwardRef(function (incomingProps, ref) {
    var props = useInputPropsMergedWithFormFieldContext(incomingProps);
    var _a = extractPropsForInputComponent(props), _b = _a.rootElementAttributes, _id = _b.id, rootElementAttributes = __rest(_b, ["id"]), baseInputComponentProps = _a.baseInputComponentProps, baseHtmlInputAttributes = _a.baseHtmlInputAttributes, ariaAttributes = _a.ariaAttributes, dataAttributes = _a.dataAttributes, restProps = _a.restProps;
    var rootRef = useRef(null);
    var combinedRefs = useForkRef(ref, rootRef);
    var inputComponentRef = useRef(null);
    var minTime = restProps.minTime, maxTime = restProps.maxTime, minuteSteps = restProps.minuteSteps, initialOpen = restProps.initialOpen, name = restProps.name, onFocus = restProps.onFocus, onBlur = restProps.onBlur;
    var rootBlurHandler = useCallback(function (e) {
        dispatch(selectSelectorTimeType(undefined));
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    }, [onBlur]);
    var _c = useCompositeComponentFocusHandlers({
        onFocus: onFocus,
        onBlur: rootBlurHandler,
        blurForNonFocusableElementsWithin: true,
        name: name,
    }), rootCompositeFocusProps = _c.rootCompositeFocusProps, compositeBlur = _c.compositeBlur;
    var readyToShowSelector = useReadyToShowSelector(initialOpen);
    var _d = useIds(_id), selectorId = _d.selectorId, inputId = _d.inputId, optionIdBase = _d.optionIdBase;
    var _e = useTimeselectHooks(props, compositeBlur), state = _e.state, dispatch = _e.dispatch;
    var currentSelectorTimeType = state.currentSelectorTimeType, highlightedHour = state.highlightedHour, highlightedMinute = state.highlightedMinute;
    var minTimeObj = minTime ? extractCompleteTime(minTime) : undefined;
    var maxTimeObj = maxTime ? extractCompleteTime(maxTime) : undefined;
    var inputChangeHandler = useCallback(function (e) {
        dispatch(inputChange(e.currentTarget.value));
    }, []);
    var inputTimeTypeChangeHandler = useCallback(function (timeType) {
        dispatch(selectSelectorTimeType(timeType));
    }, []);
    var activeHighlightId = getActiveHighlightId({
        currentSelectorTimeType: currentSelectorTimeType,
        highlightedHour: highlightedHour,
        highlightedMinute: highlightedMinute,
        optionIdBase: optionIdBase,
    });
    return (React.createElement(SRoot, __assign({}, dataAttributes, ariaAttributes, rootElementAttributes, rootCompositeFocusProps, { ref: combinedRefs, "$withFeedbackIcon": baseInputComponentProps.withFeedbackIcon }),
        React.createElement(TimeselectInput, __assign({}, baseInputComponentProps, baseHtmlInputAttributes, { id: inputId, name: name, selectorId: selectorId, state: state, onChange: inputChangeHandler, onTypeChange: inputTimeTypeChangeHandler, ref: inputComponentRef, highlightId: activeHighlightId })),
        readyToShowSelector && !!currentSelectorTimeType && (React.createElement(TimeSelectPanel, { anchorRef: inputComponentRef, id: selectorId, optionIdBase: optionIdBase, minTimeObj: minTimeObj, maxTimeObj: maxTimeObj, minuteSteps: minuteSteps, dispatch: dispatch, state: state }))));
});
var SRoot = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", ";\n  position: relative;\n  width: ", "px;\n"], ["\n  ", ";\n  position: relative;\n  width: ", "px;\n"
    /* Doing this because when open is true, the Timeselect selector
     * is shown, but there is no inputComponentRef set yet. */
])), boxSizingBorderBox, function (_a) {
    var $withFeedbackIcon = _a.$withFeedbackIcon;
    return ($withFeedbackIcon ? 142 : 114);
});
/* Doing this because when open is true, the Timeselect selector
 * is shown, but there is no inputComponentRef set yet. */
function useReadyToShowSelector(open) {
    var _a = __read(useState(!open), 2), ready = _a[0], setReady = _a[1];
    useEffect(function () {
        setReady(true);
    }, []);
    return ready;
}
function getActiveHighlightId(_a) {
    var currentSelectorTimeType = _a.currentSelectorTimeType, highlightedHour = _a.highlightedHour, highlightedMinute = _a.highlightedMinute, optionIdBase = _a.optionIdBase;
    if (isHourType(currentSelectorTimeType)) {
        return optionIdBase + highlightedHour;
    }
    else if (isMinuteType(currentSelectorTimeType)) {
        return optionIdBase + highlightedMinute;
    }
    else {
        return undefined;
    }
}
var templateObject_1;
//# sourceMappingURL=Timeselect.js.map